import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React from 'react'
import { RichText } from '../v2/components/RichText'

export type CenterContentBlockProps = Extract<Page['blocks'][0], { blockType: 'center-content' }>

function CenterContent(block: CenterContentBlockProps) {
  const { title, description, options } = block
  const hasButton = options?.hasButton
  const link = options?.link

  return (
    <Container>
      <Grid>
        <div
          className={
            'col-span-full p-8 md:p-12 lg:p-20 bg-accent-1 flex flex-col justify-center items-start'
          }
        >
          <div className={'mx-auto flex flex-col justify-center items-start'}>
            {title && (
              <Text
                variant="mediumHeading"
                className={cn('w-full mb-4', {
                  'text-center': options?.variant === 'center',
                  'text-left': options?.variant === 'left',
                })}
              >
                {title}
              </Text>
            )}
            <Text
              variant="body"
              className={cn('whitespace-pre-line text-black', {
                'text-center': options?.variant === 'center',
                'text-left': options?.variant === 'left',
              })}
            >
              <RichText content={description} />
            </Text>
            {hasButton && <CMSLink {...link} className="mt-4 md:mt-6 lg:mt-8" />}
          </div>
        </div>
      </Grid>
    </Container>
  )
}

export default CenterContent
